import { Error, IconSizes } from "@brexhq/component-library";
import type { PaletteColor } from "@brexhq/metal-foundation";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import React, { PropsWithChildren } from "react";

import { Text } from "@brexhq/shared/components/Typography/Text";

const FormErrorContainer = styled.div(({ theme }) => ({
  display: "flex",
  color: theme.colors.negative.default,
  marginTop: theme.spacing.m16,
}));

export const FormError: React.FC<
  PropsWithChildren<{ textColor: PaletteColor }>
> = ({ children, textColor }) => {
  const { spacing } = useTheme();
  return (
    <FormErrorContainer data-testid="inlinessu-formError">
      <Error size={IconSizes.LARGE} />
      <Text
        color={textColor}
        as="span"
        margin={{
          LRG: [0, 0, 0, spacing.p8],
        }}
        components={{
          LRG: "Body2",
          MED: "Body2",
          SML: "Body2",
        }}
      >
        {children}
      </Text>
    </FormErrorContainer>
  );
};
